module.exports = __webpack_public_path__ + "img/google_analytics_logo_white.aaf892ff.png";